<template>
<div class="row plain-element">
    <div v-if="!isLoggedIn()"  class="dashboard-cards">
        <NoPermissionComponent/>
    </div>
   <div v-if="getUsername() && getDivisionPlanData()" class="dashboard">
    <div class="row row-cards">
      <div class="row text-start row-back">
        <a class="back-link" @click="hasHistory() ? $router.go(-1): $router.push('/')">
          <span class="material-icons chevron-left">chevron_left</span> Back To Plan
        </a>
      </div>
    </div>
    <div class="card card-details">
      <p class="error"  v-if="getFormError()">
        <span id="formError">{{ getFormError() }}</span>
      </p>
      <p class="error"  v-else>
      </p>
      <UpdateDivisionPlanComponent
              :id = id
              :current_name = getDivisionPlanData().name
              :current_company = getDivisionPlanData().company
              :current_description = getDivisionPlanData().description
              :current_currency = getDivisionPlanData().currency
      />
    </div>
  </div>
</div>
</template>


<script>

import { mapGetters, mapActions } from "vuex";
import { hasHistory } from "@/common/general.js";
import UpdateDivisionPlanComponent from "@/components/division_plans/UpdateDivisionPlanComponent.vue";
import NoPermissionComponent from "@/components/NoPermissionComponent.vue"

export default {
  name: "DivisionPlanUpdate",
  components: {
    UpdateDivisionPlanComponent,
    NoPermissionComponent,
  },
  props: {
    id: { type: String, required: true },
  },
  data() {
    return {

    }
  },
  methods: {
    ...mapGetters(["getDivisionPlanData","getFormError", "getUsername", "isLoggedIn"]),
    ...mapActions(["fetchDivisionPlanData", "performSetFormError"]),
    hasHistory: hasHistory,
    getDivisionPlanDetails() {
      this.fetchDivisionPlanData({"id": this.id })
    },
  },

  created() {
    this.getDivisionPlanDetails();
    this.performSetFormError(null);
    document.title = "Update Division Plan";
    window.scrollTo(0,0);
  },
  beforeRouteUpdate (to, from, next) {
    this.getDivisionPlanDetails();
    next();
  }
}


</script>
